export const initialState = () => ({
  cep: "",
  street: "",
  number: "",
  noNumber: false,
  neighborhood: "",
  state: "",
  city: "",
  cityName: "",
  complements: [],
  latitude: "",
  longitude: "",
  coverageStatus: "",
  availableBoxes: [],
  cto: "",
  currentLatitude: "",
  currentLongitude: "",
  cepFromCurrentLocation: "",
  hasMadeCepFromCurrentLocationRequest: false,
  locationType: ""
})
